module.exports = __webpack_public_path__ + "static/media/travis.d14b010e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/travis.png
// module id = 206
// module chunks = 0